(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1790],{

/***/ 20427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y8": function() { return /* binding */ Radio; }
/* harmony export */ });
/* unused harmony exports RadioGroup, useRadio, useRadioGroup, useRadioGroupContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70079);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83838);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53152);
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55895);
/* harmony import */ var _chakra_ui_react_use_merge_refs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17111);
/* harmony import */ var _chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11617);
/* harmony import */ var _zag_js_focus_visible__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45317);
// ../../../react-shim.js


// src/radio.tsx


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}
var dataAttr = (condition) => condition ? "" : void 0;
var ariaAttr = (condition) => condition ? true : void 0;
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}
function callAll(...fns) {
  return function mergedFn(arg) {
    fns.forEach((fn) => {
      fn == null ? void 0 : fn(arg);
    });
  };
}

// ../../utilities/object-utils/src/index.ts
function split(object, keys) {
  const picked = {};
  const omitted = {};
  for (const [key, value] of Object.entries(object)) {
    if (keys.includes(key))
      picked[key] = value;
    else
      omitted[key] = value;
  }
  return [picked, omitted];
}

// src/radio-group.tsx



// src/use-radio-group.ts


function isInputEvent(value) {
  return value && isObject(value) && isObject(value.target);
}
function useRadioGroup(props = {}) {
  const {
    onChange: onChangeProp,
    value: valueProp,
    defaultValue,
    name: nameProp,
    isDisabled,
    isFocusable,
    isNative,
    ...htmlProps
  } = props;
  const [valueState, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultValue || "");
  const isControlled = typeof valueProp !== "undefined";
  const value = isControlled ? valueProp : valueState;
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const focus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    const rootNode = ref.current;
    if (!rootNode)
      return;
    let query = `input:not(:disabled):checked`;
    const firstEnabledAndCheckedInput = rootNode.querySelector(query);
    if (firstEnabledAndCheckedInput) {
      firstEnabledAndCheckedInput.focus();
      return;
    }
    query = `input:not(:disabled)`;
    const firstEnabledInput = rootNode.querySelector(query);
    firstEnabledInput == null ? void 0 : firstEnabledInput.focus();
  }, []);
  const uuid = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)();
  const fallbackName = `radio-${uuid}`;
  const name = nameProp || fallbackName;
  const onChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((eventOrValue) => {
    const nextValue = isInputEvent(eventOrValue) ? eventOrValue.target.value : eventOrValue;
    if (!isControlled) {
      setValue(nextValue);
    }
    onChangeProp == null ? void 0 : onChangeProp(String(nextValue));
  }, [onChangeProp, isControlled]);
  const getRootProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((props2 = {}, forwardedRef = null) => ({
    ...props2,
    ref: (0,_chakra_ui_react_use_merge_refs__WEBPACK_IMPORTED_MODULE_1__/* .mergeRefs */ .lq)(forwardedRef, ref),
    role: "radiogroup"
  }), []);
  const getRadioProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((props2 = {}, ref2 = null) => {
    const checkedKey = isNative ? "checked" : "isChecked";
    return {
      ...props2,
      ref: ref2,
      name,
      [checkedKey]: value != null ? props2.value === value : void 0,
      onChange(event) {
        onChange(event);
      },
      "data-radiogroup": true
    };
  }, [isNative, name, onChange, value]);
  return {
    getRootProps,
    getRadioProps,
    name,
    ref,
    focus,
    setValue,
    value,
    onChange,
    isDisabled,
    isFocusable,
    htmlProps
  };
}

// src/radio-group.tsx

var [RadioGroupProvider, useRadioGroupContext] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_2__/* .createContext */ .k)({
  name: "RadioGroupContext",
  strict: false
});
var RadioGroup = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .forwardRef */ .Gp)((props, ref) => {
  const {
    colorScheme,
    size,
    variant,
    children,
    className,
    isDisabled,
    isFocusable,
    ...rest
  } = props;
  const { value, onChange, getRootProps, name, htmlProps } = useRadioGroup(rest);
  const group = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({
    name,
    size,
    onChange,
    colorScheme,
    value,
    variant,
    isDisabled,
    isFocusable
  }), [
    name,
    size,
    onChange,
    colorScheme,
    value,
    variant,
    isDisabled,
    isFocusable
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RadioGroupProvider, {
    value: group
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.div */ .m$.div, {
    ...getRootProps(htmlProps, ref),
    className: cx("chakra-radio-group", className)
  }, children));
});
RadioGroup.displayName = "RadioGroup";

// src/use-radio.ts


// ../visually-hidden/src/visually-hidden.style.ts
var visuallyHiddenStyle = {
  border: "0px",
  clip: "rect(0px, 0px, 0px, 0px)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};

// src/use-radio.ts


function useRadio(props = {}) {
  const {
    defaultChecked,
    isChecked: isCheckedProp,
    isFocusable,
    isDisabled: isDisabledProp,
    isReadOnly: isReadOnlyProp,
    isRequired: isRequiredProp,
    onChange,
    isInvalid: isInvalidProp,
    name,
    value,
    id: idProp,
    "data-radiogroup": dataRadioGroup,
    "aria-describedby": ariaDescribedBy,
    ...htmlProps
  } = props;
  const uuid = `radio-${(0,react__WEBPACK_IMPORTED_MODULE_0__.useId)()}`;
  const formControl = (0,_chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_4__/* .useFormControlContext */ .NJ)();
  const group = useRadioGroupContext();
  const isWithinRadioGroup = !!group || !!dataRadioGroup;
  const isWithinFormControl = !!formControl;
  let id = isWithinFormControl && !isWithinRadioGroup ? formControl.id : uuid;
  id = idProp ?? id;
  const isDisabled = isDisabledProp ?? (formControl == null ? void 0 : formControl.isDisabled);
  const isReadOnly = isReadOnlyProp ?? (formControl == null ? void 0 : formControl.isReadOnly);
  const isRequired = isRequiredProp ?? (formControl == null ? void 0 : formControl.isRequired);
  const isInvalid = isInvalidProp ?? (formControl == null ? void 0 : formControl.isInvalid);
  const [isFocusVisible, setIsFocusVisible] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [isFocused, setFocused] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [isHovered, setHovering] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [isActive, setActive] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [isCheckedState, setChecked] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(Boolean(defaultChecked));
  const isControlled = typeof isCheckedProp !== "undefined";
  const isChecked = isControlled ? isCheckedProp : isCheckedState;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    return (0,_zag_js_focus_visible__WEBPACK_IMPORTED_MODULE_5__/* .trackFocusVisible */ .B)(setIsFocusVisible);
  }, []);
  const handleChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((event) => {
    if (isReadOnly || isDisabled) {
      event.preventDefault();
      return;
    }
    if (!isControlled) {
      setChecked(event.target.checked);
    }
    onChange == null ? void 0 : onChange(event);
  }, [isControlled, isDisabled, isReadOnly, onChange]);
  const onKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((event) => {
    if (event.key === " ") {
      setActive(true);
    }
  }, [setActive]);
  const onKeyUp = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((event) => {
    if (event.key === " ") {
      setActive(false);
    }
  }, [setActive]);
  const getRadioProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((props2 = {}, ref = null) => ({
    ...props2,
    ref,
    "data-active": dataAttr(isActive),
    "data-hover": dataAttr(isHovered),
    "data-disabled": dataAttr(isDisabled),
    "data-invalid": dataAttr(isInvalid),
    "data-checked": dataAttr(isChecked),
    "data-focus": dataAttr(isFocused),
    "data-focus-visible": dataAttr(isFocused && isFocusVisible),
    "data-readonly": dataAttr(isReadOnly),
    "aria-hidden": true,
    onMouseDown: callAllHandlers(props2.onMouseDown, () => setActive(true)),
    onMouseUp: callAllHandlers(props2.onMouseUp, () => setActive(false)),
    onMouseEnter: callAllHandlers(props2.onMouseEnter, () => setHovering(true)),
    onMouseLeave: callAllHandlers(props2.onMouseLeave, () => setHovering(false))
  }), [
    isActive,
    isHovered,
    isDisabled,
    isInvalid,
    isChecked,
    isFocused,
    isReadOnly,
    isFocusVisible
  ]);
  const { onFocus, onBlur } = formControl ?? {};
  const getInputProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((props2 = {}, ref = null) => {
    const trulyDisabled = isDisabled && !isFocusable;
    return {
      ...props2,
      id,
      ref,
      type: "radio",
      name,
      value,
      onChange: callAllHandlers(props2.onChange, handleChange),
      onBlur: callAllHandlers(onBlur, props2.onBlur, () => setFocused(false)),
      onFocus: callAllHandlers(onFocus, props2.onFocus, () => setFocused(true)),
      onKeyDown: callAllHandlers(props2.onKeyDown, onKeyDown),
      onKeyUp: callAllHandlers(props2.onKeyUp, onKeyUp),
      checked: isChecked,
      disabled: trulyDisabled,
      readOnly: isReadOnly,
      required: isRequired,
      "aria-invalid": ariaAttr(isInvalid),
      "aria-disabled": ariaAttr(trulyDisabled),
      "aria-required": ariaAttr(isRequired),
      "data-readonly": dataAttr(isReadOnly),
      "aria-describedby": ariaDescribedBy,
      style: visuallyHiddenStyle
    };
  }, [
    isDisabled,
    isFocusable,
    id,
    name,
    value,
    handleChange,
    onBlur,
    onFocus,
    onKeyDown,
    onKeyUp,
    isChecked,
    isReadOnly,
    isRequired,
    isInvalid,
    ariaDescribedBy
  ]);
  const getLabelProps = (props2 = {}, ref = null) => ({
    ...props2,
    ref,
    onMouseDown: callAllHandlers(props2.onMouseDown, stop),
    onTouchStart: callAllHandlers(props2.onTouchStart, stop),
    "data-disabled": dataAttr(isDisabled),
    "data-checked": dataAttr(isChecked),
    "data-invalid": dataAttr(isInvalid)
  });
  const getRootProps = (props2, ref = null) => ({
    ...props2,
    ref,
    "data-disabled": dataAttr(isDisabled),
    "data-checked": dataAttr(isChecked),
    "data-invalid": dataAttr(isInvalid)
  });
  const state = {
    isInvalid,
    isFocused,
    isChecked,
    isActive,
    isHovered,
    isDisabled,
    isReadOnly,
    isRequired
  };
  return {
    state,
    getCheckboxProps: getRadioProps,
    getInputProps,
    getLabelProps,
    getRootProps,
    htmlProps
  };
}
function stop(event) {
  event.preventDefault();
  event.stopPropagation();
}

// src/radio.tsx
var Radio = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .forwardRef */ .Gp)((props, ref) => {
  const group = useRadioGroupContext();
  const { onChange: onChangeProp, value: valueProp } = props;
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useMultiStyleConfig */ .jC)("Radio", { ...group, ...props });
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_6__/* .omitThemingProps */ .Lr)(props);
  const {
    spacing = "0.5rem",
    children,
    isDisabled = group == null ? void 0 : group.isDisabled,
    isFocusable = group == null ? void 0 : group.isFocusable,
    inputProps: htmlInputProps,
    ...rest
  } = ownProps;
  let isChecked = props.isChecked;
  if ((group == null ? void 0 : group.value) != null && valueProp != null) {
    isChecked = group.value === valueProp;
  }
  let onChange = onChangeProp;
  if ((group == null ? void 0 : group.onChange) && valueProp != null) {
    onChange = callAll(group.onChange, onChangeProp);
  }
  const name = (props == null ? void 0 : props.name) ?? (group == null ? void 0 : group.name);
  const {
    getInputProps,
    getCheckboxProps,
    getLabelProps,
    getRootProps,
    htmlProps
  } = useRadio({
    ...rest,
    isChecked,
    isFocusable,
    isDisabled,
    onChange,
    name
  });
  const [layoutProps, otherProps] = split(htmlProps, _chakra_ui_system__WEBPACK_IMPORTED_MODULE_6__/* .layoutPropNames */ .oE);
  const checkboxProps = getCheckboxProps(otherProps);
  const inputProps = getInputProps(htmlInputProps, ref);
  const labelProps = getLabelProps();
  const rootProps = Object.assign({}, layoutProps, getRootProps());
  const rootStyles = {
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "top",
    cursor: "pointer",
    position: "relative",
    ...styles.container
  };
  const checkboxStyles = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    ...styles.control
  };
  const labelStyles = {
    userSelect: "none",
    marginStart: spacing,
    ...styles.label
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.label */ .m$.label, {
    className: "chakra-radio",
    ...rootProps,
    __css: rootStyles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", {
    className: "chakra-radio__input",
    ...inputProps
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.span */ .m$.span, {
    className: "chakra-radio__control",
    ...checkboxProps,
    __css: checkboxStyles
  }), children && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.span */ .m$.span, {
    className: "chakra-radio__label",
    ...labelProps,
    __css: labelStyles
  }, children));
});
Radio.displayName = "Radio";



/***/ }),

/***/ 59607:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 58257:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(70079), __webpack_require__(39519)) :
  0;
})(this, (function (exports, React, PropTypes) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
  var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

  var LeadingActions = function LeadingActions(_ref) {
    var children = _ref.children;

    if (children === null || children === undefined) {
      return null;
    }

    if (Array.isArray(children)) {
      return React__default["default"].Children.map(children, function (child, index) {
        return /*#__PURE__*/React__default["default"].cloneElement(child, {
          leading: true,
          main: index === 0
        });
      });
    }

    return /*#__PURE__*/React__default["default"].cloneElement(children, {
      leading: true,
      main: true
    });
  };

  function toVal(mix) {
  	var k, y, str='';

  	if (typeof mix === 'string' || typeof mix === 'number') {
  		str += mix;
  	} else if (typeof mix === 'object') {
  		if (Array.isArray(mix)) {
  			for (k=0; k < mix.length; k++) {
  				if (mix[k]) {
  					if (y = toVal(mix[k])) {
  						str && (str += ' ');
  						str += y;
  					}
  				}
  			}
  		} else {
  			for (k in mix) {
  				if (mix[k]) {
  					str && (str += ' ');
  					str += k;
  				}
  			}
  		}
  	}

  	return str;
  }

  function clsx () {
  	var i=0, tmp, x, str='';
  	while (i < arguments.length) {
  		if (tmp = arguments[i++]) {
  			if (x = toVal(tmp)) {
  				str && (str += ' ');
  				str += x;
  			}
  		}
  	}
  	return str;
  }

  var Type = {
    ANDROID: Symbol('ANDROID'),
    IOS: Symbol('IOS'),
    MS: Symbol('MS')
  };

  var SwipeableList = function SwipeableList(_ref) {
    var _ref$actionDelay = _ref.actionDelay,
        actionDelay = _ref$actionDelay === void 0 ? 0 : _ref$actionDelay,
        children = _ref.children,
        _ref$className = _ref.className,
        className = _ref$className === void 0 ? '' : _ref$className,
        _ref$fullSwipe = _ref.fullSwipe,
        fullSwipe = _ref$fullSwipe === void 0 ? false : _ref$fullSwipe,
        _ref$destructiveCallb = _ref.destructiveCallbackDelay,
        destructiveCallbackDelay = _ref$destructiveCallb === void 0 ? 1000 : _ref$destructiveCallb,
        style = _ref.style,
        _ref$type = _ref.type,
        type = _ref$type === void 0 ? Type.ANDROID : _ref$type,
        _ref$Tag = _ref.Tag,
        Tag = _ref$Tag === void 0 ? 'div' : _ref$Tag,
        scrollStartThreshold = _ref.scrollStartThreshold,
        swipeStartThreshold = _ref.swipeStartThreshold,
        _ref$threshold = _ref.threshold,
        threshold = _ref$threshold === void 0 ? 0.5 : _ref$threshold;
    return /*#__PURE__*/React__default["default"].createElement(Tag, {
      className: clsx('swipeable-list', className),
      style: style
    }, React__default["default"].Children.map(children, function (child) {
      return /*#__PURE__*/React__default["default"].cloneElement(child, {
        actionDelay: actionDelay,
        destructiveCallbackDelay: destructiveCallbackDelay,
        fullSwipe: fullSwipe,
        listType: type,
        scrollStartThreshold: scrollStartThreshold,
        swipeStartThreshold: swipeStartThreshold,
        threshold: threshold
      });
    }));
  };

  SwipeableList.propTypes = {
    actionDelay: PropTypes__default["default"].number,
    children: PropTypes__default["default"].node,
    className: PropTypes__default["default"].string,
    fullSwipe: PropTypes__default["default"].bool,
    destructiveCallbackDelay: PropTypes__default["default"].number,
    style: PropTypes__default["default"].object,
    type: PropTypes__default["default"].oneOf(Object.values(Type)),
    Tag: PropTypes__default["default"].string,
    scrollStartThreshold: PropTypes__default["default"].number,
    swipeStartThreshold: PropTypes__default["default"].number,
    threshold: PropTypes__default["default"].number
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    Object.defineProperty(subClass, "prototype", {
      value: Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      }),
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  var ItemContext = /*#__PURE__*/React__default["default"].createContext();
  var ActionAnimation = {
    RETURN: Symbol('Return'),
    REMOVE: Symbol('Remove'),
    NONE: Symbol('None')
  };
  var DragDirection = {
    UP: "up",
    DOWN: "down",
    LEFT: "left",
    RIGHT: "right",
    UNKNOWN: "unknown"
  };
  var FPS_INTERVAL = 1000 / 60;

  var measure = function measure(element, fn) {
    var prevWidth = element.style.width;
    var prevVisibility = element.style.visibility;
    element.style.width = 'auto';
    element.style.visibility = 'hidden';
    var result = fn(element);
    element.style.width = prevWidth;
    element.style.visibility = prevVisibility;
    return result;
  };

  var initialState = {
    leadingFullSwipe: false,
    trailingFullSwipe: false,
    triggerAction: false,
    scaleLeading: false,
    scaleTrailing: false
  };

  var SwipeableListItem = /*#__PURE__*/function (_PureComponent) {
    _inherits(SwipeableListItem, _PureComponent);

    var _super = _createSuper(SwipeableListItem);

    function SwipeableListItem(props) {
      var _this;

      _classCallCheck(this, SwipeableListItem);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "setLeadingFullSwipeAction", function (action) {
        _this.leadingFullSwipeAction = action;
      });

      _defineProperty(_assertThisInitialized(_this), "setTrailingFullSwipeAction", function (action) {
        _this.trailingFullSwipeAction = action;
      });

      _defineProperty(_assertThisInitialized(_this), "resetState", function () {
        _this.dragStartPoint = {
          x: -1,
          y: -1
        };
        _this.dragDirection = DragDirection.UNKNOWN;
        _this.left = 0;
        _this.previousSwipeDistancePercent = 0;
        _this.leadingActionsOpened = false;
        _this.trailingActionsOpened = false;
      });

      _defineProperty(_assertThisInitialized(_this), "handleDragStartMouse", function (event) {
        window.addEventListener('mouseup', _this.handleDragEndMouse);
        window.addEventListener('mousemove', _this.handleMouseMove);

        _this.listElement.addEventListener('mouseup', _this.handleDragEndMouse);

        _this.listElement.addEventListener('mousemove', _this.handleMouseMove);

        _this.handleDragStart(event);
      });

      _defineProperty(_assertThisInitialized(_this), "handleDragStartTouch", function (event) {
        window.addEventListener('touchend', _this.handleDragEndTouch);
        var touch = event.targetTouches[0];

        _this.handleDragStart(touch);
      });

      _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (_ref) {
        var clientX = _ref.clientX,
            clientY = _ref.clientY;

        if (!_this.leadingActionsOpened && !_this.trailingActionsOpened) {
          _this.resetState();

          _this.setState(initialState);
        }

        var startOffsetX = 0;

        if (_this.leadingActionsOpened) {
          startOffsetX = -_this.leadingActionsWidth;
        }

        if (_this.trailingActionsOpened) {
          startOffsetX = _this.trailingActionsWidth;
        }

        _this.dragStartPoint = {
          x: clientX + startOffsetX,
          y: clientY
        };
        _this.listElement.className = 'swipeable-list-item__content';

        if (_this.leadingActionsElement) {
          _this.leadingActionsElement.className = 'swipeable-list-item__leading-actions';
        }

        if (_this.trailingActionsElement) {
          _this.trailingActionsElement.className = 'swipeable-list-item__trailing-actions';
        }

        _this.startTime = Date.now();

        _this.scheduleUpdatePosition();
      });

      _defineProperty(_assertThisInitialized(_this), "handleMouseMove", function (event) {
        if (_this.dragStartedWithinItem()) {
          var clientX = event.clientX,
              clientY = event.clientY;

          _this.setDragDirection(clientX, clientY);

          if (_this.isSwiping()) {
            event.stopPropagation();
            event.preventDefault();
            _this.left = clientX - _this.dragStartPoint.x;

            _this.scheduleUpdatePosition();
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "handleTouchMove", function (event) {
        if (_this.dragStartedWithinItem()) {
          var _event$targetTouches$ = event.targetTouches[0],
              clientX = _event$targetTouches$.clientX,
              clientY = _event$targetTouches$.clientY;

          _this.setDragDirection(clientX, clientY);

          if (!event.cancelable) {
            return;
          }

          if (_this.isSwiping()) {
            event.stopPropagation();
            event.preventDefault();
            _this.left = clientX - _this.dragStartPoint.x;

            _this.scheduleUpdatePosition();
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "handleDragEndMouse", function () {
        window.removeEventListener('mouseup', _this.handleDragEndMouse);
        window.removeEventListener('mousemove', _this.handleMouseMove);

        if (_this.listElement) {
          _this.listElement.removeEventListener('mouseup', _this.handleDragEndMouse);

          _this.listElement.removeEventListener('mousemove', _this.handleMouseMove);
        }

        _this.handleDragEnd();
      });

      _defineProperty(_assertThisInitialized(_this), "handleDragEndTouch", function () {
        window.removeEventListener('touchend', _this.handleDragEndTouch);

        _this.handleDragEnd();
      });

      _defineProperty(_assertThisInitialized(_this), "playReturnAnimationForLeadingActions", function (_ref2) {
        var to = _ref2.to,
            isIosType = _ref2.isIosType,
            playMsReturnAnimation = _ref2.playMsReturnAnimation;

        if (_this.leadingActionsElement) {
          _this.leadingActionsElement.className = clsx('swipeable-list-item__leading-actions', playMsReturnAnimation ? 'swipeable-list-item__actions--return-ms' : 'swipeable-list-item__leading-actions--return');

          if (_this.leadingActionsOpened && isIosType) {
            _this.leadingActionsElement.className += ' test-actions-opened';
          }

          if (playMsReturnAnimation) {
            var keepAnimationEnd = function keepAnimationEnd() {
              _this.leadingActionsElement.removeEventListener('animationend', keepAnimationEnd);

              _this.leadingActionsElement.style.width = 0;
            };

            _this.leadingActionsElement.addEventListener('animationend', keepAnimationEnd);
          } else {
            _this.leadingActionsElement.style.width = "".concat(to === 0 || !isIosType ? 0 : _this.leadingActionsOpened && isIosType ? _this.leadingActionsWidth : 0, "px");
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "playReturnAnimationForTrailingActions", function (_ref3) {
        var to = _ref3.to,
            isIosType = _ref3.isIosType,
            playMsReturnAnimation = _ref3.playMsReturnAnimation;

        if (_this.trailingActionsElement) {
          _this.trailingActionsElement.className = clsx('swipeable-list-item__trailing-actions', playMsReturnAnimation ? 'swipeable-list-item__actions--return-ms' : 'swipeable-list-item__trailing-actions--return');

          if (_this.trailingActionsOpened && isIosType) {
            _this.trailingActionsElement.className += ' test-actions-opened';
          }

          if (!playMsReturnAnimation) {
            _this.trailingActionsElement.style.width = "".concat(to === 0 || !isIosType ? 0 : _this.trailingActionsOpened && isIosType ? _this.trailingActionsWidth : 0, "px");
          } else {
            var keepAnimationEnd = function keepAnimationEnd() {
              _this.trailingActionsElement.removeEventListener('animationend', keepAnimationEnd);

              _this.trailingActionsElement.style.width = 0;
            };

            _this.trailingActionsElement.addEventListener('animationend', keepAnimationEnd);
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "playReturnAnimation", function () {
        var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref4$to = _ref4.to,
            to = _ref4$to === void 0 ? 0 : _ref4$to;

        var _assertThisInitialize = _assertThisInitialized(_this),
            listElement = _assertThisInitialize.listElement;

        var listType = _this.props.listType;
        var triggerAction = _this.state.triggerAction;
        var isIosType = listType === Type.IOS;
        var isMsType = listType === Type.MS;
        var playMsReturnAnimation = triggerAction && isMsType;

        if (playMsReturnAnimation) {
          var keepAnimationEnd = function keepAnimationEnd() {
            listElement.removeEventListener('animationend', keepAnimationEnd);
            listElement.style.transform = "translateX(0)";
          };

          listElement.addEventListener('animationend', keepAnimationEnd);
        }

        if (listElement) {
          listElement.className = clsx('swipeable-list-item__content', playMsReturnAnimation ? "swipeable-list-item__content--return-".concat(_this.left < 0 ? 'trailing' : 'leading', "-ms") : 'swipeable-list-item__content--return');

          if (!playMsReturnAnimation) {
            listElement.style.transform = "translateX(".concat(isIosType ? to : 0, "px)");
          }
        }

        if (_this.left < 0) {
          _this.playReturnAnimationForTrailingActions({
            to: to,
            isIosType: isIosType,
            playMsReturnAnimation: playMsReturnAnimation
          });
        } else {
          _this.playReturnAnimationForLeadingActions({
            to: to,
            isIosType: isIosType,
            playMsReturnAnimation: playMsReturnAnimation
          });
        }

        if (to === 0) {
          _this.leadingActionsOpened = false;
          _this.trailingActionsOpened = false;

          _this.resetState();
        }
      });

      _defineProperty(_assertThisInitialized(_this), "playRemoveAnimation", function () {
        var _assertThisInitialize2 = _assertThisInitialized(_this),
            listElement = _assertThisInitialize2.listElement,
            wrapperElement = _assertThisInitialize2.wrapperElement;

        var listType = _this.props.listType;

        if (listElement) {
          wrapperElement.className = 'swipeable-list-item swipeable-list-item--remove';
          listElement.className = 'swipeable-list-item__content swipeable-list-item__content--remove';
          var isIosType = listType === Type.IOS;
          var leadingFullSwipe = isIosType ? _this.leadingActionsOpened : _this.dragDirection === DragDirection.RIGHT;
          var trailingFullSwipe = isIosType ? _this.trailingActionsOpened : _this.dragDirection === DragDirection.LEFT;
          var translateLength = listElement.offsetWidth * (leadingFullSwipe ? 1 : -1);
          listElement.style.transform = "translateX(".concat(translateLength, "px)");

          _this.setState({
            leadingFullSwipe: leadingFullSwipe,
            trailingFullSwipe: trailingFullSwipe
          });

          if (leadingFullSwipe) {
            _this.leadingActionsElement.className += ' swipeable-list-item__leading-actions--return';
            _this.leadingActionsElement.style.width = "".concat(Math.abs(translateLength), "px");
          } else if (trailingFullSwipe) {
            _this.trailingActionsElement.className += ' swipeable-list-item__trailing-actions--return';
            _this.trailingActionsElement.style.width = "".concat(Math.abs(translateLength), "px");
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "playActionAnimation", function (_ref5) {
        var type = _ref5.type;

        var _assertThisInitialize3 = _assertThisInitialized(_this),
            listElement = _assertThisInitialize3.listElement;

        if (listElement) {
          switch (type) {
            case ActionAnimation.REMOVE:
              _this.playRemoveAnimation();

              break;

            case ActionAnimation.NONE:
              break;

            default:
              _this.playReturnAnimation();

          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "handleDragEnd", function () {
        if (_this.requestedAnimationFrame) {
          cancelAnimationFrame(_this.requestedAnimationFrame);
          _this.requestedAnimationFrame = null;
        }

        if (_this.isSwiping()) {
          var _this$state = _this.state,
              leadingFullSwipe = _this$state.leadingFullSwipe,
              trailingFullSwipe = _this$state.trailingFullSwipe,
              triggerAction = _this$state.triggerAction;
          var onSwipeEnd = _this.props.onSwipeEnd;

          if (onSwipeEnd) {
            onSwipeEnd(_this.dragDirection);
          }

          if (triggerAction) {
            if (leadingFullSwipe) {
              _this.leadingFullSwipeAction();

              return;
            }

            if (trailingFullSwipe) {
              _this.trailingFullSwipeAction();

              return;
            }
          }

          if (_this.leadingActionsOpened || _this.trailingActionsOpened) {
            if (_this.leadingActionsOpened) {
              _this.left = _this.leadingActionsWidth;
            } else if (_this.trailingActionsOpened) {
              _this.left = -_this.trailingActionsWidth;
            }

            _this.playReturnAnimation({
              to: _this.left
            });
          } else {
            _this.playReturnAnimation();

            _this.resetState();
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "dragStartedWithinItem", function () {
        var _this$dragStartPoint = _this.dragStartPoint,
            x = _this$dragStartPoint.x,
            y = _this$dragStartPoint.y;
        return x !== -1 && y !== -1;
      });

      _defineProperty(_assertThisInitialized(_this), "setDragDirection", function (x, y) {
        if (_this.dragDirection === DragDirection.UNKNOWN) {
          var _this$dragStartPoint2 = _this.dragStartPoint,
              startX = _this$dragStartPoint2.x,
              startY = _this$dragStartPoint2.y;
          var horizontalDistance = Math.abs(x - startX);
          var verticalDistance = Math.abs(y - startY);

          if (horizontalDistance <= _this.dragHorizontalDirectionThreshold && verticalDistance <= _this.dragVerticalDirectionThreshold) {
            return;
          }

          var angle = Math.atan2(y - startY, x - startX);
          var octant = Math.round(8 * angle / (2 * Math.PI) + 8) % 8;

          switch (octant) {
            case 0:
              if (_this.leadingActionsElement !== null && horizontalDistance > _this.dragHorizontalDirectionThreshold) {
                _this.dragDirection = DragDirection.RIGHT;
              }

              break;

            case 1:
            case 2:
            case 3:
              if (verticalDistance > _this.dragVerticalDirectionThreshold) {
                _this.dragDirection = DragDirection.DOWN;
              }

              break;

            case 4:
              if (_this.trailingActionsElement !== null && horizontalDistance > _this.dragHorizontalDirectionThreshold) {
                _this.dragDirection = DragDirection.LEFT;
              }

              break;

            case 5:
            case 6:
            case 7:
              if (verticalDistance > _this.dragVerticalDirectionThreshold) {
                _this.dragDirection = DragDirection.UP;
              }

              break;

            default:
              _this.dragDirection = DragDirection.UNKNOWN;
          }

          var onSwipeStart = _this.props.onSwipeStart;

          if (onSwipeStart && _this.isSwiping()) {
            onSwipeStart(_this.dragDirection);
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "isSwiping", function () {
        var blockSwipe = _this.props.blockSwipe;
        var horizontalDrag = _this.dragDirection === DragDirection.LEFT || _this.dragDirection === DragDirection.RIGHT;
        return !blockSwipe && _this.dragStartedWithinItem() && horizontalDrag;
      });

      _defineProperty(_assertThisInitialized(_this), "scheduleUpdatePosition", function () {
        if (_this.requestedAnimationFrame) {
          return;
        }

        _this.requestedAnimationFrame = requestAnimationFrame(function () {
          _this.requestedAnimationFrame = null;

          _this.updatePosition();
        });
      });

      _defineProperty(_assertThisInitialized(_this), "updatePosition", function () {
        if (!_this.isSwiping()) {
          return;
        }

        var elapsed = Date.now() - _this.startTime;

        if (elapsed <= FPS_INTERVAL) {
          return;
        }

        var _this$props = _this.props,
            fullSwipeThreshold = _this$props.threshold,
            listType = _this$props.listType;
        var fullSwipe = _this.fullSwipe;
        var isSwipingLeft = _this.left < 0;
        var isSwipingRight = _this.left > 0;

        if (isSwipingLeft) {
          if (_this.onlyLeadingActions) {
            _this.left = 0;
          }

          if (_this.trailingActionsElement && listType === Type.IOS) {
            _this.trailingActionsOpened = Math.abs(_this.left) > _this.trailingActionsWidth;
            _this.leadingActionsOpened = false;
          }
        }

        if (isSwipingRight) {
          if (_this.onlyTrailingActions) {
            _this.left = 0;
          }

          if (_this.leadingActionsElement && listType === Type.IOS) {
            _this.leadingActionsOpened = _this.left > _this.leadingActionsWidth;
            _this.trailingActionsOpened = false;
          }
        }

        if (_this.leadingActionsElement) {
          _this.leadingActionsElement.style.width = "".concat(_this.left < 0 ? 0 : _this.left, "px");
        }

        if (_this.trailingActionsElement) {
          _this.trailingActionsElement.style.width = "".concat(_this.left > 0 ? 0 : -_this.left, "px");
        }

        if (_this.listElement) {
          if (fullSwipe) {
            var _assertThisInitialize4 = _assertThisInitialized(_this),
                offsetWidth = _assertThisInitialize4.listElement.offsetWidth;

            var threshold = offsetWidth * fullSwipeThreshold;

            if (_this.left < -threshold) {
              _this.setState({
                leadingFullSwipe: false,
                trailingFullSwipe: true,
                triggerAction: true,
                scaleTrailing: true
              });
            } else if (_this.left > threshold) {
              _this.setState({
                leadingFullSwipe: true,
                trailingFullSwipe: false,
                triggerAction: true,
                scaleLeading: true
              });
            } else {
              _this.setState({
                scaleLeading: false,
                scaleTrailing: false,
                triggerAction: false
              });
            }
          }

          _this.listElement.style.transform = "translateX(".concat(_this.left, "px)");

          if (_this.props.onSwipeProgress) {
            var listElementWidth = _this.listElement.offsetWidth;
            var swipeDistancePercent = _this.previousSwipeDistancePercent;

            if (listElementWidth !== 0) {
              var swipeDistance = Math.max(0, listElementWidth - Math.abs(_this.left));
              swipeDistancePercent = 100 - Math.round(100 * swipeDistance / listElementWidth);
            }

            if (_this.previousSwipeDistancePercent !== swipeDistancePercent) {
              _this.props.onSwipeProgress(swipeDistancePercent, _this.dragDirection);

              _this.previousSwipeDistancePercent = swipeDistancePercent;
            }
          }
        }

        _this.startTime = Date.now();
      });

      _defineProperty(_assertThisInitialized(_this), "onActionTriggered", function (isDestructive) {
        _this.playActionAnimation({
          type: isDestructive ? ActionAnimation.REMOVE : ActionAnimation.RETURN
        });
      });

      _defineProperty(_assertThisInitialized(_this), "bindListElement", function (ref) {
        return _this.listElement = ref;
      });

      _defineProperty(_assertThisInitialized(_this), "bindWrapperElement", function (ref) {
        return _this.wrapperElement = ref;
      });

      _defineProperty(_assertThisInitialized(_this), "bindLeadingActionsElement", function (ref) {
        return _this.leadingActionsElement = ref;
      });

      _defineProperty(_assertThisInitialized(_this), "bindTrailingActionsElement", function (ref) {
        return _this.trailingActionsElement = ref;
      });

      _defineProperty(_assertThisInitialized(_this), "renderActions", function (actions, type, binder) {
        var _this$props2 = _this.props,
            actionDelay = _this$props2.actionDelay,
            destructiveCallbackDelay = _this$props2.destructiveCallbackDelay,
            listType = _this$props2.listType;
        var _this$state2 = _this.state,
            leadingFullSwipe = _this$state2.leadingFullSwipe,
            trailingFullSwipe = _this$state2.trailingFullSwipe,
            scaleLeading = _this$state2.scaleLeading,
            scaleTrailing = _this$state2.scaleTrailing;

        var _assertThisInitialize5 = _assertThisInitialized(_this),
            onActionTriggered = _assertThisInitialize5.onActionTriggered,
            setLeadingFullSwipeAction = _assertThisInitialize5.setLeadingFullSwipeAction,
            setTrailingFullSwipeAction = _assertThisInitialize5.setTrailingFullSwipeAction;

        var scaled = listType === Type.MS && (scaleLeading && type === 'leading' || scaleTrailing && type === 'trailing');
        return /*#__PURE__*/React__default["default"].createElement("div", {
          className: clsx("swipeable-list-item__".concat(type, "-actions"), _defineProperty({}, "swipeable-list-item__".concat(type, "-actions--scaled"), scaled)),
          "data-testid": "".concat(type, "-actions"),
          ref: binder
        }, /*#__PURE__*/React__default["default"].createElement(ItemContext.Provider, {
          value: {
            actionDelay: actionDelay,
            destructiveCallbackDelay: destructiveCallbackDelay,
            listType: listType,
            leadingFullSwipe: leadingFullSwipe,
            onActionTriggered: onActionTriggered,
            scaleLeading: scaleLeading,
            scaleTrailing: scaleTrailing,
            setLeadingFullSwipeAction: setLeadingFullSwipeAction,
            setTrailingFullSwipeAction: setTrailingFullSwipeAction,
            trailingFullSwipe: trailingFullSwipe
          }
        }, actions));
      });

      _this.state = initialState; // binded elements

      _this.listElement = null;
      _this.leadingActionsElement = null;
      _this.trailingActionsElement = null;
      _this.wrapperElement = null;
      _this.requestedAnimationFrame = null;
      _this.leadingActionsWidth = 0;
      _this.trailingActionsWidth = 0;
      _this.startTime = null;
      _this.previousSwipeDistancePercent = 0;
      _this.leadingFullSwipeAction = null;
      _this.trailingFullSwipeAction = null;

      _this.resetState();

      return _this;
    }

    _createClass(SwipeableListItem, [{
      key: "dragHorizontalDirectionThreshold",
      get: function get() {
        return this.props.swipeStartThreshold || 10;
      }
    }, {
      key: "dragVerticalDirectionThreshold",
      get: function get() {
        return this.props.scrollStartThreshold || 10;
      }
    }, {
      key: "fullSwipe",
      get: function get() {
        var _this$props3 = this.props,
            fullSwipe = _this$props3.fullSwipe,
            listType = _this$props3.listType;

        if (listType === Type.IOS) {
          return fullSwipe;
        }

        return true;
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this.listElement.addEventListener('mousedown', this.handleDragStartMouse);
        this.listElement.addEventListener('touchstart', this.handleDragStartTouch);
        this.listElement.addEventListener('touchend', this.handleDragEndTouch);
        this.listElement.addEventListener('touchmove', this.handleTouchMove, {
          capture: true,
          passive: false
        });

        if (this.leadingActionsElement) {
          this.leadingActionsWidth = measure(this.leadingActionsElement, function (el) {
            return el.offsetWidth;
          });
        }

        if (this.trailingActionsElement) {
          this.trailingActionsWidth = measure(this.trailingActionsElement, function (el) {
            return el.offsetWidth;
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.requestedAnimationFrame) {
          cancelAnimationFrame(this.requestedAnimationFrame);
          this.requestedAnimationFrame = null;
        }

        this.listElement.removeEventListener('mousedown', this.handleDragStartMouse);
        this.listElement.removeEventListener('touchstart', this.handleDragStartTouch);
        this.listElement.removeEventListener('touchend', this.handleDragEndTouch);
        this.listElement.removeEventListener('touchmove', this.handleTouchMove, {
          capture: true,
          passive: false
        });
      }
    }, {
      key: "onlyLeadingActions",
      get: function get() {
        return this.leadingActionsElement !== null && this.trailingActionsElement === null;
      }
    }, {
      key: "onlyTrailingActions",
      get: function get() {
        return this.leadingActionsElement === null && this.trailingActionsElement !== null;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props4 = this.props,
            children = _this$props4.children,
            className = _this$props4.className,
            leadingActions = _this$props4.leadingActions,
            trailingActions = _this$props4.trailingActions,
            onClick = _this$props4.onClick;
        return /*#__PURE__*/React__default["default"].createElement("div", {
          className: clsx('swipeable-list-item', className),
          ref: this.bindWrapperElement,
          onClick: this.leadingActionsOpened || this.trailingActionsOpened ? undefined : onClick
        }, leadingActions && this.renderActions(leadingActions, 'leading', this.bindLeadingActionsElement), /*#__PURE__*/React__default["default"].createElement("div", {
          className: "swipeable-list-item__content",
          "data-testid": "content",
          ref: this.bindListElement
        }, children), trailingActions && this.renderActions(trailingActions, 'trailing', this.bindTrailingActionsElement));
      }
    }]);

    return SwipeableListItem;
  }(React.PureComponent);

  SwipeableListItem.propTypes = {
    actionDelay: PropTypes__default["default"].number,
    blockSwipe: PropTypes__default["default"].bool,
    children: PropTypes__default["default"].node,
    className: PropTypes__default["default"].string,
    destructiveCallbackDelay: PropTypes__default["default"].number,
    fullSwipe: PropTypes__default["default"].bool,
    leadingActions: PropTypes__default["default"].node,
    listType: PropTypes__default["default"].oneOf(Object.values(Type)),
    onClick: PropTypes__default["default"].func,
    onSwipeEnd: PropTypes__default["default"].func,
    onSwipeProgress: PropTypes__default["default"].func,
    onSwipeStart: PropTypes__default["default"].func,
    scrollStartThreshold: PropTypes__default["default"].number,
    swipeStartThreshold: PropTypes__default["default"].number,
    threshold: PropTypes__default["default"].number,
    trailingActions: PropTypes__default["default"].node
  };

  var SwipeAction = function SwipeAction(_ref) {
    var children = _ref.children,
        className = _ref.className,
        _ref$destructive = _ref.destructive,
        destructive = _ref$destructive === void 0 ? false : _ref$destructive,
        _ref$main = _ref.main,
        main = _ref$main === void 0 ? false : _ref$main,
        leading = _ref.leading,
        onClick = _ref.onClick,
        trailing = _ref.trailing,
        _ref$Tag = _ref.Tag,
        Tag = _ref$Tag === void 0 ? 'span' : _ref$Tag;

    var _React$useContext = React__default["default"].useContext(ItemContext),
        actionDelay = _React$useContext.actionDelay,
        destructiveCallbackDelay = _React$useContext.destructiveCallbackDelay,
        leadingFullSwipe = _React$useContext.leadingFullSwipe,
        listType = _React$useContext.listType,
        onActionTriggered = _React$useContext.onActionTriggered,
        setLeadingFullSwipeAction = _React$useContext.setLeadingFullSwipeAction,
        setTrailingFullSwipeAction = _React$useContext.setTrailingFullSwipeAction,
        trailingFullSwipe = _React$useContext.trailingFullSwipe,
        scaleLeading = _React$useContext.scaleLeading,
        scaleTrailing = _React$useContext.scaleTrailing;

    var onHandleClick = React__default["default"].useCallback(function () {
      if (actionDelay) {
        window.setTimeout(function () {
          onActionTriggered(destructive);
          onClick();
        }, actionDelay);
        return;
      }

      onActionTriggered(destructive);

      if (destructive) {
        window.setTimeout(function () {
          return onClick();
        }, destructiveCallbackDelay);
      } else {
        onClick();
      }
    }, [actionDelay, destructive, destructiveCallbackDelay, onActionTriggered, onClick]);
    React__default["default"].useEffect(function () {
      if (leading && main) {
        setLeadingFullSwipeAction(onHandleClick);
      }
    }, [leading, main, onHandleClick, setLeadingFullSwipeAction]);
    React__default["default"].useEffect(function () {
      if (trailing && main) {
        setTrailingFullSwipeAction(onHandleClick);
      }
    }, [trailing, main, onHandleClick, setTrailingFullSwipeAction]);
    return /*#__PURE__*/React__default["default"].createElement(Tag, {
      className: clsx('swipe-action', {
        'swipe-action__leading': leading,
        'swipe-action__trailing': trailing,
        'swipe-action__leading--full-swipe-rest': leading && leadingFullSwipe && !main && listType === Type.IOS,
        'swipe-action__leading--full-swipe-main': leading && leadingFullSwipe && main && listType === Type.IOS,
        'swipe-action__trailing--full-swipe-rest': trailing && trailingFullSwipe && !main && listType === Type.IOS,
        'swipe-action__trailing--full-swipe-main': trailing && trailingFullSwipe && main && listType === Type.IOS,
        'swipe-action__grayed': listType === Type.MS && !(scaleLeading || scaleTrailing)
      }, className),
      onClick: onHandleClick
    }, children);
  };

  SwipeAction.propTypes = {
    children: PropTypes__default["default"].node.isRequired,
    className: PropTypes__default["default"].string,
    destructive: PropTypes__default["default"].bool,
    main: PropTypes__default["default"].bool,
    leading: PropTypes__default["default"].bool,
    onClick: PropTypes__default["default"].func.isRequired,
    trailing: PropTypes__default["default"].bool,
    Tag: PropTypes__default["default"].string
  };

  var TrailingActions = function TrailingActions(_ref) {
    var children = _ref.children;

    if (children === null || children === undefined) {
      return null;
    }

    if (Array.isArray(children)) {
      return React__default["default"].Children.map(children, function (child, index) {
        return /*#__PURE__*/React__default["default"].cloneElement(child, {
          main: index === children.length - 1,
          trailing: true
        });
      });
    }

    return /*#__PURE__*/React__default["default"].cloneElement(children, {
      main: true,
      trailing: true
    });
  };

  exports.LeadingActions = LeadingActions;
  exports.SwipeAction = SwipeAction;
  exports.SwipeableList = SwipeableList;
  exports.SwipeableListItem = SwipeableListItem;
  exports.TrailingActions = TrailingActions;
  exports.Type = Type;

  Object.defineProperty(exports, '__esModule', { value: true });

}));


/***/ })

}]);